<validation-results [validationResults]="validationModel" *ngIf="validationModel.validationResults.length > 0"></validation-results>
<div [hidden]="!vehicles">
    <h2>Vehicle Results</h2>
    <fieldset *ngFor="let vehicleResult of vehicles; let i = index">
        <div class="row">
            <div class="col-sm-2 col-md-1 mvd_form-group">
                <label>Year</label>
                <div class="mvd_form-control">{{ vehicleResult.modelYear }}</div>
            </div>
            <div class="col-sm-6 col-md-5 col-lg-4 mvd_form-group">
                <label>Make</label>
                <div class="mvd_form-control">{{ vehicleResult.makeDisplayValue }}</div>
            </div>
            <div class="col-sm-6 col-md-5 col-lg-4 mvd_form-group">
                <label>Model</label>
                <div class="mvd_form-control">{{ vehicleResult.modelDisplayValue }}</div>
            </div>
            <div class="col-sm-6 col-lg-5 mvd_form-group">
                <label>Body Style</label>
                <div class="mvd_form-control">{{ vehicleResult.bodyStyleTypeID | displayValue:bodyStyleTypes }}</div>
            </div>
            <div class="col-sm-2 mvd_form-group">
                <label>Price</label>
                <div class="mvd_form-control">{{ vehicleResult.factoryListPrice }}</div>
            </div>
            <div class="col-sm-3 col-md-2 mvd_form-group">
                <label>Unladen Weight</label>
                <div class="mvd_form-control">{{ vehicleResult.unladenWeight }}</div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-2 col-md-1 mvd_form-group">
                <label>Axles</label>
                <div class="mvd_form-control">{{ vehicleResult.axles }}</div>
            </div>
            <div class="col-sm-3 col-lg-2 mvd_form-group">
                <label>GVW Rating</label>
                <div class="mvd_form-control">{{ vehicleResult.grossVehicleWeightRatingTypeID | displayValue:grossVehicleWeightRatingTypes }}</div>
            </div>
            <div class="col-sm-5 col-lg-6 mvd_form-group">
                <label>Fuel Type</label>
                <div class="mvd_form-control">{{ vehicleResult.fuelTypeID | displayValue:fuelTypes }}</div>
            </div>
            <div class="col-sm-2 col-md-1 mvd_form-group">
                <label>Tonnage</label>
                <div class="mvd_form-control">{{ vehicleResult.tonnageRatingTypeID | displayValue:tonnageRatingDisplayTypes }}</div>
            </div>
        </div>
        <button class="btn--default" type="button" (click)="onVehicleSelect(i)">Select</button>
    </fieldset>
</div>
<form [formGroup]="addVehicleForm" [hidden]="vehicles" autocomplete="off">
    <h2>Vehicle Details <button class="icon--add btn--default" type="button" data-bs-toggle="modal" data-bs-target="#vehicleNotesModal" *ngIf="canAddNotes && dataLoaded">Notes</button></h2>
    <fieldset>
        <div class="row">
            <div class="col-sm-6 col-md-4 col-lg-3 mvd_form-group">
                <label class="required" title="* Required">VIN</label>
                <input class="mvd_form-control" type="text" formControlName="vin" *ngIf="canEditVin && !!vehicle" autofocus />
                <control-validation-messages control="vin" *ngIf="canEditVin"></control-validation-messages>
                <div class="mvd_form-control" *ngIf="!canEditVin">{{vehicle.vin}}</div>
            </div>
            <div class="col-sm-6 col-md-4 mvd_form-group" *ngIf="dataLoaded">
                <label>VIN Type</label>
                <select class="mvd_form-control" formControlName="vinTypeID">
                    <option [ngValue]="null">- Select -</option>
                    <option *ngFor="let t of vinTypes" [ngValue]="t.id">{{ t.displayValue }}</option>
                </select>
                <control-validation-messages control="vinTypeID"></control-validation-messages>
            </div>
            <div class="col-sm-6 col-md-4 col-lg-3 col-lg-2 mvd_form-group">
                <label>Vehicle Number</label>
                <input class="mvd_form-control" type="text" readonly="readonly" formControlName="vehicleNumber" *ngIf="!!vehicle" />
            </div>
        </div>
        <div class="row">
            <div class="col-sm-4 col-md-3 col-lg-2 mvd_form-group" *ngIf="!canModifyMOFR">
                <label>Month FR</label>
                <div class="mvd_form-control" *ngIf="!!vehicle">{{ addVehicleForm.get('monthFirstRegistered').value }}</div>
            </div>
            <div class="col-sm-4 col-md-3 col-lg-2 mvd_form-group" *ngIf="canModifyMOFR">
                <label>Month FR</label>
                <input class="mvd_form-control" type="text" maxlength="2" oninput="javascript: if (this.value) this.value = this.value.replace(/[^0-9]/g,'');" formControlName="monthFirstRegistered" *ngIf="!!vehicle" />
            </div>
            <div class="col-sm-4 col-md-3 col-lg-2 mvd_form-group" *ngIf="!canModifyMOFR">
                <label>Year FR</label>
                <div class="mvd_form-control" *ngIf="!!vehicle">{{ addVehicleForm.get('yearFirstRegistered').value }}</div>
            </div>
            <div class="col-sm-4 col-md-3 col-lg-2 mvd_form-group" *ngIf="canModifyMOFR">
                <label>Year FR</label>
                <input class="mvd_form-control" type="text" maxlength="4" oninput="javascript: if (this.value) this.value = this.value.replace(/[^0-9]/g,'');" formControlName="yearFirstRegistered" *ngIf="!!vehicle" />
            </div>
        </div>
        <div class="row">
            <div class="col-sm-6 col-md-4 mvd_form-group">
                <label class="required" tite="* Required">Vehicle Type</label>
                <select class="mvd_form-control" formControlName="vehicleTypeID" *ngIf="!!vehicle">
                    <option [ngValue]="null" selected="selected">- Select -</option>
                    <option *ngFor="let t of vehicleTypes" [ngValue]="t.id">{{ t.displayValue }}</option>
                </select>
                <control-validation-messages control="vehicleTypeID"></control-validation-messages>
            </div>
            <div class="col-sm-6 col-md-4 col-lg-3 mvd_form-group">
                <label>Make <a class="icon--add" href="javascript:void(0)" *ngIf="!hasBeenSaved && !blockUserInput && ifCabAndChaise()" data-bs-toggle="modal" data-bs-target="#addMakeModal" title="Add Make" (click)="addNewMake();"></a></label>
                <Autocomplete #makeAutocomplete servicePath="vehicle/make/name" serviceIdPath="vehicle/make" value="id" text="makeDisplayValue" secondaryText="ncicCode" itemNotFoundMessage="Make Not Found" [disabled]="blockUserInput || !ifCabAndChaise()"></Autocomplete>
            </div>
            <div class="col-sm-6 col-md-4 col-lg-3 mvd_form-group">
                <label>Model <a class="icon--add" href="javascript:void(0)" *ngIf="!forcedModel && !hasBeenSaved && !blockUserInput && (ifCabAndChaise() || !vehicle.modelID)" data-bs-toggle="modal" data-bs-target="#addModelModal" title="Add Model" (click)="addNewModel();"></a></label>
                <Autocomplete [hidden]="forcedModel" #modelAutocomplete servicePath="vehicle/model/make/{parentId}/name" serviceIdPath="vehicle/model" value="id" text="modelValue" itemNotFoundMessage="Model Not Found" [disabled]="blockUserInput || (!ifCabAndChaise() && vehicle.modelID)"></Autocomplete>
                <div class="mvd_form-control" *ngIf="forcedModel">{{ forcedModel }}</div>
            </div>
            <div class="col-sm-2 col-lg-1 mvd_form-group">
                <label class="required" tite="* Required">Year</label>
                <input class="mvd_form-control" type="text" formControlName="modelYear" *ngIf="!!vehicle" />
                <control-validation-messages control="modelYear"></control-validation-messages>
            </div>
        </div>
        <div class="row" *ngIf="dataLoaded">
            <div class="col-sm-6 col-md-4 mvd_form-group">
                <label>Original Primary Color</label>
                <select class="mvd_form-control" formControlName="primaryColorTypeID">
                    <option [ngValue]="null">- Select -</option>
                    <option *ngFor="let t of colorTypes" [ngValue]="t.id">{{ t.displayValue }}</option>
                </select>
            </div>
            <div class="col-sm-6 col-md-4 col-lg-3 mvd_form-group">
                <label>Original Secondary Color</label>
                <select class="mvd_form-control" formControlName="secondaryColorTypeID">
                    <option [ngValue]="null">- Select -</option>
                    <option *ngFor="let t of colorTypes" [ngValue]="t.id">{{ t.displayValue }}</option>
                </select>
            </div>
        </div>
        <div class="row" *ngIf="dataLoaded">
            <div class="col-sm-6 col-md-4 mvd_form-group">
                <label class="required" tite="* Required">Body Style Type</label>
                <select class="mvd_form-control" formControlName="bodyStyleTypeID">
                    <option [ngValue]="null">- Select -</option>
                    <option *ngFor="let t of bodyStyleTypes" [ngValue]="t.id">{{ t.displayValue }}</option>
                </select>
                <control-validation-messages control="bodyStyleTypeID"></control-validation-messages>
            </div>
            <div class="col-sm-6 col-md-5 col-lg-6 mvd_form-group">
                <label class="required" tite="* Required">Fuel Type</label>
                <select class="mvd_form-control" formControlName="fuelTypeID">
                    <option [ngValue]="null">- Select -</option>
                    <option *ngFor="let t of activeFuelTypes" [ngValue]="t.id">{{ t.displayValue }}</option>
                </select>
                <control-validation-messages control="fuelTypeID"></control-validation-messages>
            </div>
            <div class="col-sm-3 col-lg-2 mvd_form-group">
                <label class="required" tite="* Required">Factory List Price</label>
                <div *ngIf="isFlipReadOnly()" class="mvd_form-control">{{ addVehicleForm.get('factoryListPrice').value }}</div>
                <input id="factoryListPrice" *ngIf="!isFlipReadOnly()" class="mvd_form-control" type="text" formControlName="factoryListPrice" (keypress)="isNumericKey($event)" />
                <control-validation-messages control="factoryListPrice"></control-validation-messages>
            </div>
        </div>
        <div class="row" *ngIf="dataLoaded">
            <div class="col-sm-3 col-md-2 mvd_form-group">
                <label>Tonnage</label>
                <select class="mvd_form-control" formControlName="tonnageRatingDisplayTypeId">
                    <option [ngValue]="null">- Select -</option>
                    <option *ngFor="let t of tonnageRatingDisplayTypes" [ngValue]="t.id">{{ t.value }}</option>
                </select>
                <control-validation-messages control="tonnageRatingDisplayTypeId"></control-validation-messages>
            </div>
            <div class="col-sm-2 mvd_form-group">
                <label>Unladen Weight</label>
                <input class="mvd_form-control" formControlName="unladenWeight" type="text" />
                <control-validation-messages control="unladenWeight"></control-validation-messages>
            </div>
            <div class="col-sm-2 col-lg-1 mvd_form-group">
                <label>Axles</label>
                <input class="mvd_form-control" type="text" formControlName="axles" />
                <control-validation-messages control="axles"></control-validation-messages>
            </div>
            <div class="col-sm-4 col-md-2 mvd_form-group">
                <label>Combined Axles</label>
                <input class="mvd_form-control" formControlName="combinedAxles" type="text" (keypress)="isNumericKey($event)" />
                <control-validation-messages control="combinedAxles"></control-validation-messages>
            </div>
        </div>
        <div class="row" *ngIf="dataLoaded && isLengthWidthRequired()">
            <div class="col-sm-3 col-lg-2 mvd_form-group">
                <label>Length</label>
                <div class="input--ft">
                    <input class="mvd_form-control" formControlName="trailerLength" type="text" />
                </div>
                <control-validation-messages control="trailerLength"></control-validation-messages>
            </div>
            <div class="col-sm-3 col-md-2 col-lg-1 mvd_form-group">
                <label>Width</label>
                <div class="input--ft">
                    <input class="mvd_form-control" formControlName="trailerWidth" type="text" (keypress)="isNumericKey($event)" />
                </div>
                <control-validation-messages control="trailerWidth"></control-validation-messages>
            </div>
            <div class="col-sm-3 col-md-2 col-lg-1 mvd_form-group" *ngIf="dataLoaded">
                <label>Seats</label>
                <input class="mvd_form-control" formControlName="seats" type="text" />
                <control-validation-messages control="seats"></control-validation-messages>
            </div>
        </div>
    </fieldset>
</form>
<ng-container *ngIf="displayBrands && dataLoaded">
    <vehicle-brands [nmvtisBrands]="vehicle.nmvtisBrands" [vehicleTypeId]="vehicle.vehicleTypeID" [vehicleId]="vehicle.id" [(vehicleBrands)]="vehicle.vehicleBrands" [(newVehicleBrand)]="vehicle.newVehicleBrand"></vehicle-brands>
</ng-container>
<!-- Modal - add make & model -->
<div class="modal fade" id="addMakeModal" tabindex="-1" role="dialog" aria-labelledby="addMakeModal">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                <h4 class="modal-title" id="labelButtons">Add New Make & Model</h4>
            </div>
            <div class="modal-body">
                <VehicleMakeModel #vehicleMakeAdd [addingNewMake]=true [vehicleTypeId]="vehicle?.vehicleTypeID"></VehicleMakeModel>
            </div>
            <div class="modal-footer">
                <div class="btn--group">
                    <button class="btn--primary" type="button" data-bs-dismiss="modal">Close</button>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- Modal - add model -->
<div class="modal fade" id="addModelModal" tabindex="-1" role="dialog" aria-labelledby="addModelModal">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                <h4 class="modal-title" id="labelButtons">Add New Model</h4>
            </div>
            <div class="modal-body">
                <VehicleMakeModel #vehicleModelAdd [addingNewMake]=false [vehicleMakeId]="vehicle?.makeID" [vehicleMakeDisplayValue]="vehicle?.makeDisplayValue" [vehicleTypeId]="vehicle?.vehicleTypeID"></VehicleMakeModel>
            </div>
            <div class="modal-footer">
                <div class="btn--group">
                    <button class="btn--primary" type="button" data-bs-dismiss="modal">Close</button>
                </div>
            </div>
        </div>
    </div>
</div>
<!--Notes Modal -->
<ng-container *ngIf="dataLoaded">
    <div class="modal fade" id="vehicleNotesModal" tabindex="-1" role="dialog" aria-labelledby="labelNotes">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                    <h4 class="modal-title" id="labelNotes">Notes</h4>
                </div>
                <div class="modal-body--scroll">
                    <note [(notes)]="vehicleNotes" [noteIdentificationValue]="vehicle.vehicleNumber" [noteIdentificationTypeId]="2" [countDisplayClass]="'note-count'" [isWip]="false"></note>
                </div>
                <div class="modal-footer">
                    <div class="btn--group">
                        <button class="btn--primary" type="button" data-bs-dismiss="modal">Close</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-container>